import { get, post, put, del } from '../lib/apiClient';

/** GET /groups?limit=&lastEvaluatedKey= */
export const listGroups = (query) => get('/groups', { query });

/** GET /groups/{groupId} */
export const getGroup = (groupId) => get(`/groups/${encodeURIComponent(groupId)}`);

/** POST /groups — { name, description, settings } */
export const createGroup = (payload) => post('/groups', payload);

/** PUT /groups/{groupId} — partial update */
export const updateGroup = (groupId, payload) =>
  put(`/groups/${encodeURIComponent(groupId)}`, payload);

/** DELETE /groups/{groupId} */
export const deleteGroup = (groupId) => del(`/groups/${encodeURIComponent(groupId)}`);

/** POST /groups/{groupId}/members — { userId } */
export const addMember = (groupId, payload) =>
  post(`/groups/${encodeURIComponent(groupId)}/members`, payload);

/** DELETE /groups/{groupId}/members/{userId} */
export const removeMember = (groupId, userId) =>
  del(`/groups/${encodeURIComponent(groupId)}/members/${encodeURIComponent(userId)}`);

/** PUT /groups/{groupId}/members/{userId}/role — { role } */
export const updateMemberRole = (groupId, userId, payload) =>
  put(
    `/groups/${encodeURIComponent(groupId)}/members/${encodeURIComponent(userId)}/role`,
    payload
  );
